import * as columnSerializer from './column';
import {ResultTables, Actions} from '../stores/Form';
import {NewTable, Activation, Rt, Status} from '../types';
import {migrateToNewPalette} from '@priority-software/priority-utils/lib/palette';

export interface SerializedJson {
    name: string;
    columnsMap: Map<string, columnSerializer.Column>;
    table: string;
    isPainted: boolean;
    self: string;
    hasAttachment: boolean;
    title: string;
    level: string;
    zoomField: string;
    form: string;
}

export function serialize(json: NewTable): SerializedJson {
    const columnsMap = new Map();
    const columns = json.NewColumn;
    const design = json.Designs && json.Designs[0];
    if (columns) {
        for (const jsonColumn in columns) {
            let designedColumn;
            if (design) {
                // design.Design.find won't work despite @babel/polyfill
                for (const dColumn in design.Design) {
                    if (design.Design[dColumn].field === columns[jsonColumn].field) {
                        designedColumn = design.Design[dColumn];
                        break;
                    }
                }
            }
            const column = columnSerializer.serialize(columns[jsonColumn], designedColumn);
            columnsMap.set(column.field, column);
        }
    }
    return {
        name: json.name,
        columnsMap,
        table: json.table,
        self: json.self,
        isPainted: json.drawn === '1',
        hasAttachment: json.hassimplepicture === '1',
        title: json.title,
        level: json.level,
        zoomField: json.zoomfield,
        form: json.form
    };
}

export function serializeActivations(activations: Array<Activation>): Actions {
    if (!activations || !activations.length) {
        return [];
    }

    return activations.reduce((actArr, activation) => {
        const {title, type, ename, exec} = activation;
        actArr.push({
            title: title,
            type: String.fromCharCode(parseInt(type)),
            ename: ename,
            exec
        });

        return actArr;
    }, []);
}

export function serializeStatuses(statuses: Status[]): Map<string, string> {
    const statusMap = new Map();
    if (
        !statuses ||
        !statuses.length ||
        !statuses[0] ||
        !statuses[0].Status ||
        !statuses[0].Status.length
    ) {
        return statusMap;
    }
    statuses[0].Status.forEach(status => {
        const color = migrateToNewPalette(status.color);
        statusMap.set(status.statdes, color);
    });
    return statusMap;
}

export function serializeResultTables(RT: Array<Rt>): ResultTables {
    const results = RT?.reduce((map, item) => {
        const [formNum, colNum, rowNum, rowColor, sameValue, value] = item.FV.split('\t');

        // Create form, if needed
        map.has(formNum) || map.set(formNum, []);

        // Create new row map if needed
        if (!map.get(formNum)[rowNum]) {
            map.get(formNum)[rowNum] = new Map();
        }

        // Add column data to row
        map.get(formNum)[rowNum].set(colNum, {color: rowColor, sameValue: sameValue, value: value});

        return map;
    }, new Map());

    results?.forEach((form, index) => {
        const newEntires = new Map([...form.entries()]);
        newEntires.delete(0);
        results.set(index, newEntires);
    });

    // results?.forEach((form, index) => {
    //     results.set(index, new Map([...form.entries()].sort((a, b) => {
    //         return Number(a[0])-Number(b[0]);
    //     })));
    // })

    return results;
}

export function getSession(json) {
    return (
        json &&
        json.Form[0].Position &&
        json.Form[0].Position[0] &&
        json.Form[0].Position[0].session
    );
}

export function serializeSumTotal(json) {
    return json && json.Form[0].Error && json.Form[0].Error[0] && json.Form[0].Error[0].message;
}

export const serializeMacros = formData => {
    const macroArray = formData?.Macros ? formData?.Macros : formData?.InitTitles?.[0]?.Macros;

    const macros = macroArray?.[0]?.Macro;
    return macros || [];
};

export const serializeMacro = data => {
    return data?.Form?.[0].Macros?.[0].Macro?.[0];
};

export const getErrorMessage = data => {
    const error = data?.Form?.[0]?.Error?.[0];
    if (error && error.messagetype === 'stop') {
        return error.message;
    }
    return null;
};
